module.exports = __webpack_public_path__ + "img/1561086494.195e5d46.jpg";